import React from 'react';
import axios from 'axios';
import { Author } from '../../components/Author/Author';
import { AuthorData } from '../../types/pages/author';
import Head from 'next/head';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { replaceTripshepherdWithSeeSight } from '../../utils/trip-sheppered-text';

type AuthorPageProps = {
  authorData: AuthorData | null;
};

const AuthorPage: React.FC<AuthorPageProps> = ({ authorData }) => {
  const router = useRouter();

  //If author data is undefined or null
  if (!authorData) {
    return (
      <div className="flex h-[calc(100vh-100px)] justify-center items-center gap-5 flex-col px-10 xl:mr-32">
        <Image
          src="/missing-data-illustration.svg"
          alt="missing data icon"
          width={272}
          height={181}
          className="w-[200px] h-[150px] sm:w-[272px] sm:h-[181px]"
        />
        <h2 className="text-black13 text-xs sm:text-base lg:text-lg font-semibold leading-none">
          No Author Data Found!
        </h2>
        <div className="text-center text-gray75 text-xs sm:text-base font-normal max-w-[400px]">
          We couldn&apos;t find information about the author. Please check back
          later or explore other content.
        </div>
        <button
          className="h-[32] bg-primary text-white text-center text-xs sm:text-sm px-5 rounded-[30px] py-2 sm:py-3 shadow"
          onClick={() => router.push('/blog')}
        >
          Explore Blogs
        </button>
      </div>
    );
  }

  const authorName = authorData.name
    ? `${authorData.name} - Writer in See Sight Tours`
    : 'Unknown Author';
  const authorBio = authorData.bio
    ? authorData.bio
    : 'Learn more about our author.';

  return (
    <>
      <Head>
        <meta name="og:title" content={authorName} />
        <meta name="og:description" content={authorBio} />
        <title>{authorName}</title>
        <meta name="description" content={authorBio} />
        <link
          href={`https://www.seesight-tours.com/author/${router.query.id}`}
          rel="canonical"
          key="canonical"
        />
        <meta name="og:image" content={'/vertical-seesight-logo.png'} />
      </Head>
      <div className="h-full">
        <Author authorData={authorData} />
      </div>
    </>
  );
};

export const getServerSideProps = async (context: any) => {
  const { id } = context.params;

  try {
    const response = await axios.get(
      `${process.env.NEXT_PUBLIC_FIREBASE_CONNECTION}/author/${id}`
    );
    const authorData: AuthorData = response.data.author;

    return {
      props: {
        authorData: replaceTripshepherdWithSeeSight(authorData)
      }
    };
  } catch (error) {
    console.error('Error fetching author data:', error);
    return {
      props: {
        authorData: null
      }
    };
  }
};

export default AuthorPage;
